import React from "react";
import styled from "styled-components";
import { focusTokens } from "../../config/designTokens";
import { focusRing } from "../../styles/mixins";

const SkipLinkButton = styled.a`
  position: absolute;
  left: -9999px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  z-index: 9999;
  padding: 16px 24px;
  background-color: ${props => props.theme.background.paper};
  color: ${props => props.theme.text.primary};
  text-decoration: none;
  font-weight: 600;
  border: ${focusTokens.ring.width} ${focusTokens.ring.style} var(--color-focus-ring, ${focusTokens.color.light});

  &:focus {
    position: fixed;
    left: 16px;
    top: 16px;
    width: auto;
    height: auto;
    overflow: visible;
    ${focusRing()}
  }
`;

interface SkipLinkProps {
    targetId?: string;
    children?: React.ReactNode;
}

export const SkipLink: React.FC<SkipLinkProps> = ({
    targetId = "main-content",
    children = "Skip to main content"
}) => {
    return (
        <SkipLinkButton
            href={`#${targetId}`}
            data-testid="skip-link"
        >
            {children}
        </SkipLinkButton>
    );
};
